import React, {useEffect} from "react";
import "./styles.scss";
import "./mobile.scss";
import {withRouter} from "react-router-dom/cjs/react-router-dom.min";
import {FormHeader, Navigator, SectionHeader} from "../../../components";
import {getLanguage} from "../../../utils/environment";
import Footer from "../../footer/index";
import {useLocation} from "react-router-dom/cjs/react-router-dom";

const TermsConditions = (props) => {
  const len = getLanguage();
  const location = useLocation();

  useEffect(() => {
    window.scrollTo({top: 0, behavior: "smooth"});
  }, [location.pathname]);

  return (
    <>
      <div className="container">
        <Navigator
          data={{
            size: "lg",
            icon: "arrow-left",
            title: "Terms and Conditions",
          }}
          onClickBack={() => {
            props.history.push("/");
          }}
        />
        <div className={"policy-wrapper"}>
          <div className={"tpw__top"}>
            <FormHeader
              data={{
                size: "lg x",
                mainLayerStyles: "mb-4 pb-2",
                formHeader: "Terms and Conditions",
              }}
            />
            <SectionHeader
              data={{
                size: "md x",
                title: "",
              }}
            />
          </div>
          <div className={"tpw__body"}>
            <p>
              Last Updated: June 25 2025

              Welcome to hopeofanewera.org. These Terms and Conditions  govern your access to and use of our
              website and services. By using our site, you agree to be bound by these Terms. If you do not agree, please
              do not use our services.
            </p>

            <h2>About Us</h2>
            <p>hopeofanewera.org is a Sri Lanka-based online platform offering</p>
            <ul>
              <li>
                Local and international news.
              </li>
              <li>
                Paid advertising space.
              </li>
              <li>
                Subscription-based content.
              </li>
              <li>
                Donation programs.
              </li>
              <li>
                A job marketplace.
              </li>
            </ul>

            <h2>Use of Website</h2>
            <p>You agree to</p>
            <ul>
              <li>Use the site for lawful purposes only.</li>
              <li>Not engage in unauthorized access or disruption of the platform.</li>
              <li>Provide accurate, current, and complete information when registering or transacting.</li>
              <li>Not reproduce, copy, or redistribute our content without permission.</li>
            </ul>

            <h2>User Accounts</h2>
            <p>To access certain features, you may need to create an account</p>
            <ul>
              <li>
                You are responsible for maintaining the confidentiality of your login information.
              </li>
              <li>
                You agree to notify us immediately of any unauthorized use of your account.
              </li>
              <li>
                We reserve the right to suspend or terminate accounts that violate our Terms.
              </li>
            </ul>

            <h2>Paid Services</h2>
            <p>We offer subscription plans, advertising packages, and job posting services</p>
            <ul>
              <li>
                All payments must be made via approved payment gateways
              </li>
              <li>
                By purchasing, you agree to our Refund Policy
              </li>
              <li>
                We reserve the right to reject or remove any content that violates laws, ethics, or our policies
              </li>
            </ul>

            <h2>Content Ownership</h2>
            <p>All content on hopeofanewera.org — including news articles, graphics, logos, and user-submitted material
              — is the property of hopeofanewera.org or its content providers.</p>
            <ul>
              <li>
                You may not edit, reproduce, or redistribute content without permission
              </li>
            </ul>

            <h2>Donations</h2>
            <p>All donations are voluntary and non-refundable. Donation records will be securely stored. You are responsible for providing accurate information when making a donation.</p>

            <h2>Contact Us</h2>
            <p>
              If you have questions about this Privacy Policy or how we handle your data, please contact:
              <ul>
                <li>📧 Email: contact@hopeofanewera.org</li>
                <li>🌐 Website: https://www.hopeofanewera.org</li>
              </ul>
            </p>

          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};
export default withRouter(TermsConditions);
